var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4492 11.3625H5.12077C3.39722 11.3625 2 12.7598 2 14.4833V39.4495C2 41.173 3.39722 42.5702 5.12077 42.5702H39.4492C41.1728 42.5702 42.57 41.173 42.57 39.4495V14.4833C42.57 12.7598 41.1728 11.3625 39.4492 11.3625Z",
    stroke: "#6C8195",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0422 2H28.5252C29.3529 2 30.1467 2.32879 30.7319 2.91405C31.3172 3.49931 31.646 4.29309 31.646 5.12077V11.3623H12.9214V5.12077C12.9214 4.29309 13.2502 3.49931 13.8354 2.91405C14.4207 2.32879 15.2145 2 16.0422 2Z",
    stroke: "#6C8195",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3638 22.2852H33.2092",
    stroke: "#3B72FF",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3638 31.6475H33.2092",
    stroke: "#3B72FF",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCases);
export default __webpack_public_path__ + "static/media/cases.8ba9da841f7b3e86aee8c23ad3eeb894.svg";
export { ForwardRef as ReactComponent };